import { testimonials } from "@/mocks/dramas";

export default function VoiceSection() {
  return (
    <section className="py-16 md:py-20" aria-labelledby="voice-about-title">
      <div className="mx-auto max-w-page px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[0.8fr_1.2fr] lg:items-start">
          <div className="lg:sticky lg:top-28">
            <span className="text-xs font-label tracking-[0.3em] text-accent-400">用户口碑</span>
            <h2 id="voice-about-title" className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              读者的反馈，是我们调整榜单的依据
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              每一条读者反馈都会被记录，用于复核评分与更新剧集信息。这也是我们能持续把榜单做准的原因之一。
            </p>
          </div>

          <ul className="space-y-5">
            {testimonials.map((item, index) => (
              <li
                key={item.name}
                className="flex gap-5 rounded-lg border border-background-200/70 bg-background-100/60 p-6"
              >
                <span className="font-heading text-3xl font-black text-background-300">
                  {String(index + 1).padStart(2, "0")}
                </span>
                <div>
                  <div className="flex flex-wrap items-center gap-3">
                    <span className="font-label text-sm text-foreground-950">{item.name}</span>
                    <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-[11px] font-label text-accent-400">
                      {item.role}
                    </span>
                  </div>
                  <p className="mt-3 text-sm leading-relaxed text-foreground-700">「{item.text}」</p>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}